import React from 'react';

import HeroSection from 'components/sections/hero/hero.component';
import Features from 'components/sections/features/features.component';
import Services from 'components/sections/services/services.component';
import Testimonials from 'components/sections/testimonials/testimonials.component';
import Clients from 'components/sections/clients/clients.component';

import { IntersectionObserver } from 'components/intersection-observer';
import { MotionRouteContainer } from 'components/common/MotionRouteContainer';
import { routeContainerVariantsHome } from 'theme/motion.variants';

import {
  features1,
  features2,
  features3
} from 'components/sections/features/features.data';

const Home = () => {
  return (
    <MotionRouteContainer
      variants={routeContainerVariantsHome}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <HeroSection />
      <IntersectionObserver>
        <Features {...features1} />
      </IntersectionObserver>
      <IntersectionObserver>
        <Features {...features2} />
      </IntersectionObserver>
      <IntersectionObserver>
        <Services />
      </IntersectionObserver>
      <IntersectionObserver>
        <Features {...features3} />
      </IntersectionObserver>
      <IntersectionObserver>
        <Testimonials />
      </IntersectionObserver>
      <Clients />
    </MotionRouteContainer>
  );
};

export default Home;
